import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { Button, type ButtonProps } from 'components/Button/Button';
import type { FC } from 'react';

type Props = Partial<ButtonProps> & {
  downloadConfigCallback: () => Promise<void>;
};
export const DownloadConfigButton: FC<Props> = ({
  downloadConfigCallback,
  ...otherProps
}) => {
  const [loading, setLoading] = useLoadingState();
  return (
    <Button
      loading={loading === 'LOADING'}
      variant='tertiary'
      type='button'
      size='xxs'
      icon='fa-download'
      iconStyle='regular'
      onClick={() => {
        withLoadingIndicator(setLoading)(downloadConfigCallback);
      }}
      {...otherProps}
    />
  );
};
